import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { LOGO_URL } from "../lib/api";

export const Header = () => {
  const navigate = useNavigate();
  const isAdmin = !!localStorage.getItem("mybeema_token");

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-[#E2E8F0]"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-logo-link">
          <img src={LOGO_URL} alt="MY BEEMA" className="h-12 w-12 rounded-full object-cover ring-2 ring-[#006A4E]/20" />
          <div className="leading-tight">
            <div className="font-display text-xl font-bold text-[#0B192C]">MY BEEMA<span className="text-[#006A4E]">.in</span></div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-[#4A5568]">One Stop. All Protection.</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[#0B192C]">
          <button onClick={() => scrollTo("products")} data-testid="nav-products" className="hover:text-[#006A4E] transition-colors">Products</button>
          <button onClick={() => scrollTo("about")} data-testid="nav-about" className="hover:text-[#006A4E] transition-colors">Why Us</button>
          <button onClick={() => scrollTo("contact")} data-testid="nav-contact" className="hover:text-[#006A4E] transition-colors">Contact</button>
        </nav>

        <div className="flex items-center gap-3">
          {isAdmin ? (
            <Button
              data-testid="header-admin-dashboard-btn"
              variant="outline"
              className="rounded-full border-[#006A4E] text-[#006A4E] hover:bg-[#006A4E] hover:text-white"
              onClick={() => navigate("/admin")}
            >
              Dashboard
            </Button>
          ) : (
            <Button
              data-testid="header-admin-login-btn"
              variant="ghost"
              className="rounded-full text-[#0B192C] hover:bg-[#E6F0ED] hover:text-[#006A4E]"
              onClick={() => navigate("/admin/login")}
            >
              Admin Login
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};
